import DataSheetCustomViewOptionsStore from "csi/middleware/customView/options/DataSheetCustomViewOptionsStore";
import CustomViewDialogStore from "csi/middleware/customView/CustomViewDialogStore";
import { ComponentItem } from "designSystem/types/component-item-types";
import { action, computed, makeObservable } from "mobx";
import { ChangeEvent, FunctionComponent, SyntheticEvent } from "react";
import { ICustomViewDataSheetSizeChartOptions } from "src/ProductSpec/SizeChart/CustomViewSizeChartOptions";
import { ICustomViewDataSheetSizeChartDropDownOptions, SizeChartReviewPrintOldReviewOptionsType } from "./CustomViewSizeChartOptions";

/**
 * This store contains information about Size chart options
 */
class SizeChartReviewDataSheetCustomViewOptionsStore extends DataSheetCustomViewOptionsStore<ICustomViewDataSheetSizeChartOptions> {
	/** all the dropdown boxes selection options for the custom view */
	readonly sizeChartDropDownOptions: ICustomViewDataSheetSizeChartDropDownOptions;

	constructor(
		sizeChartDropDownOptions: ICustomViewDataSheetSizeChartDropDownOptions,
		component: FunctionComponent,
		customViewDialogStore: CustomViewDialogStore,
		options?: ICustomViewDataSheetSizeChartOptions,
	) {
		super(sizeChartDropDownOptions, component, customViewDialogStore, options);
		makeObservable(this);
		this.sizeChartDropDownOptions = sizeChartDropDownOptions;
	}

	@action setReviewPrintOldReviews = (event: ChangeEvent<{}>, item: ComponentItem): void => {
		const { options } = this;

		if (item.id === SizeChartReviewPrintOldReviewOptionsType.PRINT_REVIEWS_DEFAULT) {
			options.reviewPrintAllSuppliers = false;
		}

		options.reviewPrintOldReviews = item.id;
	};

	@action setReviewPrintAllSuppliers = (event: SyntheticEvent, value: boolean): void => {
		this.options.reviewPrintAllSuppliers = value;
	};

	@action setReviewPrintEvaluationPerSize = (event: SyntheticEvent, value: boolean): void => {
		const { options } = this;

		if (!value) {
			options.reviewPrintOldReviews = SizeChartReviewPrintOldReviewOptionsType.PRINT_REVIEWS_DEFAULT;
			options.reviewPrintAllSuppliers = false;
		}

		options.reviewPrintEvaluationPerSize = value;
	};

	@computed get selectedReviewPrintOldReviews(): ComponentItem {
		const { reviewPrintOldReviews } = this.options;
		return this.sizeChartDropDownOptions.sizeChartReviewPrintOldReviewOptions.find((item) => item.id === reviewPrintOldReviews);
	};
}

export = SizeChartReviewDataSheetCustomViewOptionsStore;